import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const baseURI = "http://localhost:8080";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({baseUrl: baseURI}),
    tagTypes: ["transaction", "admin"],
    endpoints: (builder) => ({
        // DELETE RECORD
        deleteTransaction: builder.mutation({
            query: (recordId) => ({
                url: "/api/transaction",
                method: "DELETE",
                body: {id: recordId}, // more standard
            }),
            invalidatesTags: ["transaction"],
        }),
    }),
});

export const {useDeleteTransactionMutation} = apiSlice;
export default apiSlice;
